import { render, staticRenderFns } from "./termo-aceite.vue?vue&type=template&id=72ebf364&"
import script from "./termo-aceite.vue?vue&type=script&lang=js&"
export * from "./termo-aceite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports